import { useMemo } from 'react';
import { cx } from '@emotion/css';
import Grid from '@mui/material/Grid';

import { firstLevelContainerCx } from './styles';

import { PageRowProps } from './types';

function PageRow(props: PageRowProps) {
  const {
    children,
    size = false,
    padding,
    firstLevelContainer = false,
    style,
    className,
    ...resProps
  } = props;

  const handlePadding = useMemo(() => {
    if (!padding) return '';

    if (typeof padding === 'number') return padding;

    return parseInt(padding) > 0 ? padding : 16;
  }, [padding]);

  return (
    <Grid
      item
      xs={size ? size : 12}
      style={{
        ...(padding && { padding: handlePadding }),
        ...style,
      }}
      className={cx(firstLevelContainerCx(firstLevelContainer), className)}
      {...resProps}
    >
      {children}
    </Grid>
  );
}

export default PageRow;
